import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.47715 4.47715 0 10 0H54C59.5228 0 64 4.47715 64 10V54C64 59.5228 59.5228 64 54 64H10C4.47715 64 0 59.5228 0 54V10Z"
      className="bgColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.4329 34.5801L27.3965 31.4225C27.0398 31.3476 26.7046 31.6198 26.7046 31.9842V39.9364H42.197C42.831 39.9364 43.3449 39.4224 43.3449 38.7885V35.7035C43.3449 35.1605 42.9644 34.6917 42.4329 34.5801ZM27.6324 30.2991C26.5624 30.0744 25.5566 30.8909 25.5566 31.9842V41.0843H42.197C43.4649 41.0843 44.4928 40.0564 44.4928 38.7885V35.7035C44.4928 34.6174 43.7317 33.6799 42.6688 33.4567L27.6324 30.2991Z"
      className="mainColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.7931 34.0835C31.8526 33.7721 32.1532 33.5679 32.4646 33.6274L37.5922 34.6066C37.9036 34.666 38.1078 34.9666 38.0483 35.278C37.9889 35.5894 37.6883 35.7936 37.3769 35.7341L32.2493 34.7549C31.9379 34.6955 31.7337 34.3948 31.7931 34.0835Z"
      className="mainColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5996 20.9138C17.5996 20.5968 17.8566 20.3398 18.1736 20.3398H20.5196C21.1407 20.3398 21.7136 20.6743 22.019 21.2151L27.2533 30.4853C27.4092 30.7613 27.3117 31.1115 27.0357 31.2673C26.7597 31.4232 26.4096 31.3257 26.2537 31.0497L21.0194 21.7795C20.9176 21.5992 20.7266 21.4878 20.5196 21.4878H18.1736C17.8566 21.4878 17.5996 21.2308 17.5996 20.9138Z"
      className="mainColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9155 22.0255C22.1386 22.2507 22.1368 22.6141 21.9116 22.8372C21.1482 23.5935 20.1958 24.9198 19.8166 26.4093C19.4461 27.8644 19.6183 29.4652 21.0713 30.9182C22.6905 32.5374 23.6255 33.4568 24.1361 33.948C24.3291 34.1336 24.457 34.2538 24.5367 34.3264C24.6025 34.3609 24.6626 34.4087 24.7129 34.4696L24.713 34.4697C24.7233 34.4822 24.7516 34.5165 24.7771 34.5576C24.7847 34.5697 24.7974 34.591 24.8105 34.6185C24.8195 34.6376 24.849 34.7005 24.8612 34.7872C24.8706 34.8546 24.8935 35.1378 24.6337 35.3299C24.4181 35.4894 24.1936 35.4355 24.1582 35.427L24.1571 35.4267C24.0534 35.4019 23.9787 35.3513 23.9729 35.3475L23.9726 35.3472C23.9501 35.3328 23.9315 35.3188 23.9201 35.3101C23.8962 35.2916 23.8715 35.2708 23.8488 35.2511C23.7584 35.1726 23.5971 35.0224 23.3403 34.7753C22.8213 34.276 21.8798 33.3502 20.2596 31.7299C18.4732 29.9435 18.2513 27.9046 18.7041 26.126C19.1482 24.3818 20.2367 22.8805 21.1038 22.0217C21.329 21.7986 21.6924 21.8003 21.9155 22.0255ZM23.8276 35.2004C23.831 35.2045 23.8305 35.2041 23.8275 35.2003L23.8276 35.2004Z"
      className="mainColor"
    />
    <path
      d="M30.2361 38.8514C30.2361 41.5071 28.0833 43.6599 25.4276 43.6599C22.772 43.6599 20.6191 41.5071 20.6191 38.8514C20.6191 36.1958 22.772 34.043 25.4276 34.043C28.0833 34.043 30.2361 36.1958 30.2361 38.8514Z"
      className="bgColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.4276 42.512C27.4493 42.512 29.0882 40.8731 29.0882 38.8514C29.0882 36.8298 27.4493 35.1909 25.4276 35.1909C23.4059 35.1909 21.7671 36.8298 21.7671 38.8514C21.7671 40.8731 23.4059 42.512 25.4276 42.512ZM25.4276 43.6599C28.0833 43.6599 30.2361 41.5071 30.2361 38.8514C30.2361 36.1958 28.0833 34.043 25.4276 34.043C22.772 34.043 20.6191 36.1958 20.6191 38.8514C20.6191 41.5071 22.772 43.6599 25.4276 43.6599Z"
      className="mainColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.4267 39.9984C26.0607 39.9984 26.5746 39.4845 26.5746 38.8505C26.5746 38.2165 26.0607 37.7026 25.4267 37.7026C24.7927 37.7026 24.2788 38.2165 24.2788 38.8505C24.2788 39.4845 24.7927 39.9984 25.4267 39.9984ZM25.4267 41.1464C26.6947 41.1464 27.7225 40.1185 27.7225 38.8505C27.7225 37.5826 26.6947 36.5547 25.4267 36.5547C24.1587 36.5547 23.1309 37.5826 23.1309 38.8505C23.1309 40.1185 24.1587 41.1464 25.4267 41.1464Z"
      className="mainColor"
    />
    <path
      d="M46.401 40.3069C46.401 42.1581 44.9003 43.6588 43.0491 43.6588C41.1979 43.6588 39.6973 42.1581 39.6973 40.3069C39.6973 38.4558 41.1979 36.9551 43.0491 36.9551C44.9003 36.9551 46.401 38.4558 46.401 40.3069Z"
      className="bgColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.0491 42.5109C44.2663 42.5109 45.253 41.5241 45.253 40.3069C45.253 39.0897 44.2663 38.103 43.0491 38.103C41.8319 38.103 40.8452 39.0897 40.8452 40.3069C40.8452 41.5241 41.8319 42.5109 43.0491 42.5109ZM43.0491 43.6588C44.9003 43.6588 46.401 42.1581 46.401 40.3069C46.401 38.4558 44.9003 36.9551 43.0491 36.9551C41.1979 36.9551 39.6973 38.4558 39.6973 40.3069C39.6973 42.1581 41.1979 43.6588 43.0491 43.6588Z"
      className="mainColor"
    />
    <path
      d="M44.1863 40.307C44.1863 40.9329 43.679 41.4402 43.0531 41.4402C42.4273 41.4402 41.9199 40.9329 41.9199 40.307C41.9199 39.6812 42.4273 39.1738 43.0531 39.1738C43.679 39.1738 44.1863 39.6812 44.1863 40.307Z"
      className="mainColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.4863 31.3751C29.4863 29.7894 30.7718 28.5039 32.3575 28.5039H38.113C40.015 28.5039 41.5568 30.0457 41.5568 31.9477V33.4887H40.4089V31.9477C40.4089 30.6797 39.381 29.6518 38.113 29.6518H32.3575C31.4058 29.6518 30.6342 30.4234 30.6342 31.3751H29.4863Z"
      className="mainColor"
    />
  </svg>
);

const LandscapeIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default LandscapeIcon;
